export default function getResource(label) {
    const resources = {
        getFreeSameDayDelivery: 'Get FREE Same-Day Delivery',
        getFreeSameDayDeliverySMUI: 'Get {color:red}FREE{color} Same-Day Delivery',
        tryNowForFree: 'Try Now For Free',
        signUp: 'Sign Up',
        startSavingWithSDU: 'Start saving with Sephora Same-Day Unlimited.',
        startSaving: 'Start saving with a *FREE 30-day trial* of Sephora Same-Day Unlimited.'
    };

    return resources[label];
}
